module.exports = __webpack_public_path__ + "media/images/lavita_banner/composed_banner/banner__sponsor__athlete-9ac6fc2332970c5d81acf47a599ac17d.png";